'use client';

import { useIntl } from 'react-intl';
import { getFormattedHoursMinutesWithUnitsInSpans } from '@alltrails/data-formatting/dateTimeFormatters';
import styles from './TrailStats.module.scss';

type TrailStatsProps = {
  durationMinutes: string;
  averageTimeToComplete?: {
    value: string;
    unit: string;
  };
  preventResize?: boolean;
};

const Duration = ({ durationMinutes, averageTimeToComplete, preventResize }: TrailStatsProps) => {
  const intl = useIntl();

  const statValueClass = preventResize ? styles.statValueSm : styles.statValue;
  return (
    <div className={styles.stat}>
      {averageTimeToComplete ? (
        <span className={statValueClass}>
          {averageTimeToComplete.value}
          <span>{averageTimeToComplete.unit}</span>
        </span>
      ) : (
        <span className={statValueClass}>{getFormattedHoursMinutesWithUnitsInSpans(intl, parseInt(durationMinutes) * 60, false)}</span>
      )}
      <span className={styles.statLabel}>{intl.formatMessage({ defaultMessage: 'Estimated time' })}</span>
    </div>
  );
};

export default Duration;
